module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - Marjan Homes Inc. - April 4- 2025.0bd1eed6.pdf";